/*
 * All the javascript of the website
 *----------------------------------------------------------*/

document.body.classList.add('state-loaded')

import _ from './source/helper/HelperFunctions';


import VideoJS from './source/lib/lib.videojs';
import TOC from './source/modules/module.toc';
import Popup from './source/lib/lib.popup';
//import Parallax from './source/lib/lib.parallax';
import MobileMenu from './source/lib/lib.mobile-menu';
import VideoLazyLoad from './source/modules/module.video-lazy-load';
import toggleTieringTables from './source/lib/lib.toggle-tiering-tables';
import scrollNudge from './source/lib/lib.scroll-nudge';
import stickyCta from './source/lib/lib.sticky-cta';
import titleNavigation from './source/lib/lib.title-navigation';
import rowTitelGenresFilter from './source/lib/lib.row-titel-genres-filter';

import Carousel from './source/modules/module.carousel';
import customCarousel from './source/modules/custom.carousel';
import Slider from './source/modules/module.slider';
import ContentCalendar from './source/modules/module.content-calendar'
import GenreTitles from './source/modules/module.genres-titles';
import heroVideoControls from './source/modules/hero-video';

// snowplow implementation
import snowplow from './source/snowplow/snowplow';

import './source/lib/lib.lazy-load';

// Pollyfill
if (typeof Array.from == 'undefined') {
	Array.from = _.toArray
}

// Track dragging
document.body.addEventListener('touchmove', _.throttle(function () {
	window._touchDrag = true
}));
document.body.addEventListener('touchstart', function () {
	window._touchDrag = false
});

/* ===================================================================== */

if (typeof window.checkBreakpoint != 'undefined') {
	window.addEventListener('resize', _.throttle(window.checkBreakpoint, 50))
}

if (typeof window.checkScroll != 'undefined') {
	window.addEventListener('scroll', _.throttle(window.checkScroll, 50))
}

/**
 * initialize snowplow
 */
new snowplow();

/**
 * If there's a content calendar on the page, initialize this script.
 */
if (document.getElementsByClassName('content-calendar')) {
	_.toArray(document.getElementsByClassName('content-calendar')).forEach(item => {
		new ContentCalendar(item);
	})
}

/**
 * if the content manager added several tiering tables and wants to be able to toggle them, initialize the toggle
 */
if (document.getElementById("tiering-table-1")) {
	new toggleTieringTables();
}

/**
 * initialize the scroll nudge if the nudge and the scroll target are present
 */
if (document.querySelector('.nudge-wrapper .nudge') && document.querySelector('.scroll-nudge-target')) {
	new scrollNudge();
}

/**
 * initialize stikcy cta functionality if the 'sticky-cta-active' is present in the DOM
 */
initStickyCta();
window.addEventListener('resize', () => {
	initStickyCta();
});

function initStickyCta() {
	new stickyCta();
}

/**
 * initialize the next and previous functionality for title modules
 * with more than 5 titles
 */
initTitleNavigation();
window.addEventListener('resize', () => {
	initTitleNavigation();
});
function initTitleNavigation() {
	for (const module of document.querySelectorAll('.row-navigation-titels')) {
		new titleNavigation(module);
	}
}

/**
 * initialize the next and previous functionality for title modules
 * with more than 5 titles
 */
initRowTitelGenres();
function initRowTitelGenres() {
	for (const module of document.querySelectorAll('.row-titel-genres-filter')) {
		new rowTitelGenresFilter(module);
	}
}

/**
 * If there is a video on the page, initialize it. We pass an array of all items with the 'videojs' class.
 */

if (document.querySelectorAll('video').length > 0) {
	new VideoJS(_.toArray(document.querySelectorAll('video:not(.lazy)')));
}

/**
 * if there's a content toggle button, hide the 'after' content, and enable ability to display it
 */

if (document.querySelector('button.toggle-content')) {

	const beforeContent = document.querySelector('.content-before');
	const afterContent = document.querySelector('.content-after');
	const toggleButton = document.querySelector('button.toggle-content');

	afterContent.classList.add('d-none');

	toggleButton.addEventListener('click', () => {
		beforeContent.classList.add('d-none');
		afterContent.classList.remove('d-none');
	});
}

if (document.querySelector('.video.lazy')) {
	const lazyVideos = _.toArray(document.querySelectorAll('.video.lazy'));

	lazyVideos.forEach(vid => new VideoLazyLoad(vid));
}

/**
 * Initalize the carousels
 */
_.toArray(document.getElementsByClassName('carousel')).forEach(function (node) {
	node.classList.contains('slider') ? new Slider(node) : new Carousel(node)
})

/**
 * Initalize the trailers and cast carousels
 */
if (document.querySelector('body').clientWidth > 1199) {
	_.toArray(document.querySelectorAll('.trailers-carousel, .cast-carousel, .timeline-carousel, .fightcards-carousel')).forEach(function (node) {
		new customCarousel(node);
	});
}

/**
 * initialize controls for hero video element
 */
if (document.getElementById('onbeperkt-series-films-v1')) {
	new heroVideoControls();
}

/**
 * initialize content toggle
 */
if (document.querySelector('.display-toggle')) {

	function setActiveSection(toggle, toggles, targets) {

		_.toArray(toggles).forEach(toggle => {
			toggle.classList.remove('active');
		});

		toggle.classList.add('active');

		_.toArray(targets).forEach(target => {
			target.classList.add('fightcard-hidden');
		});

		document.getElementById(toggle.getAttribute('target-id')).classList.remove('fightcard-hidden');
	}

	const targets = [];
	const toggles = [];

	_.toArray(document.querySelectorAll('.display-toggle')).forEach(el => {

		_.toArray(el.querySelectorAll('.toggle')).forEach(toggle => {
			toggles.push(toggle);

			if (!toggle.hasAttribute('target-id')) {
				return;

				if (document.getElementById(toggle.getAttribute('target-id')) === null) {
					return;
				}
			}

			targets.push(document.getElementById(toggle.getAttribute('target-id')));

			toggle.addEventListener('click', () => {
				setActiveSection(toggle, toggles, targets)
			});
		});
	});

	setActiveSection(document.querySelector('.toggle.active'), toggles, targets);
}

/**
 * If there's a quicknav on the page then initialize it by passing an array of all h2's DIRECTLY within a section on the page.
 */
if (document.getElementsByClassName('vl-toc').length > 0) {
	new TOC(_.toArray(document.querySelectorAll('section > h2')))
}

/**
 * If there are popup triggers on the page, we will initialize them all with the popup class.
 * In any case, we pass ALL of the popup triggers as an array into the VlPopup class.
 */
if (document.getElementsByClassName('popup-trigger').length > 0) {
	new Popup(_.toArray(document.getElementsByClassName('popup-trigger')));
}

/**
 * If there's genre title containers, initialize them!
 */
if (document.querySelector('.vl-related.has-genres')) {
	_.toArray(document.querySelectorAll('.vl-related.has-genres')).forEach(element => {
		new GenreTitles(element);
	})
}

/**
 * toggle timeline content
 */
_.toArray(document.getElementsByClassName('timeline-item')).forEach(function ($container) {
	_.toArray($container.getElementsByClassName('toggle-content')).forEach(function ($toggle) {
		$toggle.addEventListener('click', function (e) {

			e.preventDefault()

			// Toggle active item
			$container.classList.toggle('active')
		})
	})
})


// --------------------------------------------------------------------------------------------
// Tabcontainer support

_.toArray(document.getElementsByClassName('accordion-item')).forEach(function ($container) {
	_.toArray($container.getElementsByClassName('accordion-title')).forEach(function ($toggle) {
		$toggle.addEventListener('click', function (e) {

			e.preventDefault()

			// Toggle active item
			$container.classList.toggle('active')

			// Toggle siblings
			_.toArray($container.parentNode.childNodes).forEach(function ($el) {
				if ($el != $container && $el.tagName == 'LI') {
					$el.classList.remove('active')
				}
			})
		})
	})
})

/**
 * Initializing the mobile menu JS to get that working properly.
 */
new MobileMenu(document.getElementById('mobile-trigger'));


// --------------------------------------------------------------------------------------------
// Tier table support

(function () {
	_.toArray(document.querySelectorAll('.tiering')).forEach(function (container) {

		var cards = _.toArray(container.querySelectorAll('.tier'))

		cards.forEach(function (node) {

			node.addEventListener('click', function () {

				var active = container.querySelector('.tier.selected')
				active && active.classList.remove('selected')

				node.classList.add('selected')

				// Switch button
				var base = node.querySelector('.btn')

				_.toArray(container.querySelectorAll('.tier-selection .btn:not(.white-transparency)')).forEach(function (btn) {
					btn.innerHTML = base.innerHTML
					btn.setAttribute('href', base.getAttribute('href'))
				});

				// set tier name on usps for animation
				var tierPosition = base.getAttribute('position');
				container.querySelector('.tier-usps__mobile').setAttribute('tier_active', tierPosition);
			});
		});

	})
})();

// --------------------------------------------------------------------------------------------
// Scroll click support

(function () {

	// Autoscroll
	if (document.querySelectorAll('.page-wrapper a[href^="#"]').length > 0) {
		_.toArray(document.querySelectorAll('.page-wrapper a[href^="#"]')).forEach(function (node) {

			if (node.getAttribute('href') != '#' && !node.classList.contains('no-autoscroll')) {
				node.addEventListener('click', function (e) {
					e.preventDefault()

					_.scrollTo(node.getAttribute('href'), 600);

					var target = document.querySelector(node.getAttribute('href'))
					if (target && target.classList.contains('accordion-content')) {
						target.parentNode.classList.add('active')
					}
				})
			}
		})
	}

	// Scroll hint
	var hint = document.querySelector('.scroll-hint')

	if (hint) {
		hint.addEventListener('click', function (e) {

			e.preventDefault()

			var section = this

			do {
				section = section.parentNode

			} while (!section.classList.contains('et_pb_section'))


			if (typeof section.nextElementSibling != 'undefined') {
				_.scrollTo(section.nextElementSibling, 600);
			}
		})
	}


	var top = document.querySelector('.scroll-top')

	if (top) {
		top.addEventListener('click', function (e) {
			e.preventDefault()
			_.scrollTo(document.body, 600);
		})

		window.addEventListener('scroll', _.throttle(function () {

			let scrollTop = window.pageYOffset || document.documentElement.scrollTop
			let offset = window.innerHeight * 0.25


			if (scrollTop > offset) {
				top.classList.add('active')
			}
			else {
				top.classList.remove('active')
			}

		}, 50))
	}

})();


// --------------------------------------------------------------------------------------------
// Tiering overload


// Tiering is not supported / used at the moment
// (function( $ ){

// 	if( typeof window._tiering == 'undefined' )
// 	{
// 		return;
// 	}

// 	// Class definition
// 	var Tiering = function()
// 	{
// 		// prep replacements
// 		this._replacement = []

// 		// Run 
// 		this.fetchTier()
// 	}


// 	Tiering.prototype = 
// 	{
// 		constructor: Tiering

// 		/**
// 		 * Internal cache manager
// 		 * 
// 		 * @param 	string key The key the cache attribute is referred by
// 		 * @param 	void value = null Optionaly set the value to use the cache in a setter context
// 		 * @return 	void
// 		 */
// 		, cache : function ( key, value )
// 		{
// 			if( typeof window.sessionStorage == 'undefined' )
// 			{
// 				return false
// 			}

// 			if( value )
// 			{
// 				window.sessionStorage.setItem( key, JSON.stringify( value ) )
// 			}
// 			else 
// 			{
// 				value = window.sessionStorage.getItem( key )
// 				value = value ? JSON.parse( value ) : false
// 			}

// 			return value
// 		}

// 		/**
// 		 * Fetch tiering information, calls @see run after tier is fetched succesfully
// 		 * 
// 		 */
// 		, fetchTier : function()
// 		{
// 			if( typeof fetch == 'undefined' )
// 			{
// 				return;
// 			}

// 			var cache = this.cache( 'tiers' )

// 			if( cache )
// 			{
// 				if( cache.length >= 2 || typeof window.sessionStorage == 'undefined' || window.sessionStorage.getItem('vl_flag_show_tiers') == 'off' )
// 				{
// 					return this.run( cache )
// 				}
// 			}

// 			var headers = new Headers()
// 				headers.append( 'content-type', 'application/json' )

// 			var self = this
// 			var request = {
// 				method: 'POST',
// 				headers: headers,
// 				credentials: 'include',
// 				body: JSON.stringify({"query":"{ tiers { id pricing { oneTime, recurring } promoPricing { oneTime, recurring } presentation { title features } } }"}),
// 				redirect: 'follow'
// 			}

// 			fetch("https://api.videoland.com/subscribe/subscription/graphql", request)
// 				.then(response => response.json() )
// 				.then(function( response ){
// 					if( typeof response.data == 'undefined' )
// 					{
// 						return;
// 					}

// 					if( typeof response.data.tiers != 'object' )
// 					{
// 						return;
// 					}

// 					self.cache( 'tiers', response.data.tiers )
// 					self.run( response.data.tiers )
// 				})

// 				// just fallback on empty
// 				.catch( function(){ 
// 					self.cache( 'tiers', [] )
// 					self.run( [] )
// 				});
// 		}

// 		/**
// 		 * Retrieve the cheapest tier
// 		 * 
// 		 * @param 	array tiers An array containing the availible tiers
// 		 * @return 	json
// 		 */
// 		, getCheapestTier : function( tiers )
// 		{
// 			// Get lowest priced tier
// 			var _tier = false

// 			for( var i in tiers )
// 			{
// 				var tier = tiers[ i ]

// 				if( !_tier ||  tier.pricing.recurring < _tier.pricing.recurring )
// 				{
// 					_tier = tier 
// 				}
// 			}

// 			return _tier
// 		}

// 		/**
// 		 * Run the module
// 		 * 
// 		 * @param 	array tiers An array containing the availible tiers 
// 		 */
// 		, run : function( tiers )
// 		{
// 			// push datalayer
// 			window.dataLayer = typeof window.dataLayer != 'undefined' ? window.dataLayer : []
// 			window.dataLayer.push({
// 				'featureFlags': tiers.length >= 2 ? 'vl_flag_show_tiers' : 'none'
// 			})

// 			// trigger to document
// 			$(document).trigger( 'tiering', tiers.length >= 2 ? 'on' : 'off' )

// 			// set localstorage per request
// 			if( typeof window.sessionStorage != 'undefined' )
// 			{
// 				if( !window.sessionStorage.getItem('vl_flag_show_tiers') )
// 				{
// 					window.sessionStorage.setItem('vl_flag_show_tiers', tiers.length < 2 ? 'off' : 'on' )
// 				}		
// 			}

// 			// Run replacement
// 			if( tiers.length >= 2 || typeof window.sessionStorage != 'undefined' && window.sessionStorage.getItem('vl_flag_show_tiers') == 'on' )
// 			{
// 				this._runReplacements( tiers )
// 			}
// 		}

// 		/**
// 		 * Run the replacements on the content node 
// 		 * 
// 		 * @access  private
// 		 * @param 	json tiers An array containing the tiering information
// 		 */
// 		, _runReplacements : function( tiers )
// 		{
// 			// Replace urls
// 			$('a').filter(function(){ return $(this).attr('href') == window._tiering.base }).attr( 'href', window._tiering.url )

// 			if( tiers.length < 2 )
// 			{
// 				return;
// 			}

// 			// Form replacement
// 			$('.intro-email form').each(function(){
// 				this.action = window._tiering.url
// 				delete this.dataset.alt
// 			})

// 			// Textual replacements
// 			var tier  = this.getCheapestTier( tiers )
// 			var price = (tier.pricing.recurring + '' ).replace('.', ',')

// 			this._replacement = []
// 			this._replacement.push([ 'daarna €8,99', 'vanaf €' + price ])
// 			this._replacement.push([ 'voor €8,99', 'vanaf €' + price ])
// 			this._replacement.push([ '€8,99', 'vanaf €' + price ])

// 			for( var i = 0; i < this._replacement.length; i++ )
// 			{
// 				this._runReplacement( document.body, this._replacement[i][0], this._replacement[i][1] )
// 			}
// 		}

// 		/**
// 		 * Iterative callback for @see _runReplacements
// 		 * 
// 		 * @access  private
// 		 * @param   parent Node the node to trigger the replacements in
// 		 * @param   string search The text to search for
// 		 * @param   string replace The text to replace the text with
// 		 */
// 		, _runReplacement : function( parent, search, replace ) 
// 		{
// 			for ( var i = 0; i < parent.childNodes.length; ++i ) 
// 			{
// 				var child = parent.childNodes[ i ];

// 				if( child.tagName == 'SCRIPT' || child.tagName == 'IFRAME' )
// 				{
// 					continue;
// 				}

// 				// Contents not found
// 				if( -1 === child.textContent.indexOf( search ) )
// 				{	
// 					continue;
// 				}

// 				// text node, execute replacement
// 				if( child.nodeType === 3 )
// 				{
// 					child.textContent = child.textContent.replace( search, replace )
// 				}

// 				// traverse deeper
// 				else 
// 				{
// 					this._runReplacement( child, search, replace )
// 				}
// 			}
// 		}
// 	}

//     // Run interface
//     new Tiering()


// })( window.jQuery );


(function () {

	// --------------------------------------------------------------------------------------------
	// Enhance click support

	var selector = [
		'.vl__news-item',
		'.et_pb_rtl_featured',
		'.et_pb_rtl_title_preview article'
	].join(',')


	_.toArray(document.querySelectorAll(selector)).forEach(function (node) {

		var click = function (e) {
			if (_.isDragging()) {
				return;
			}

			var target = e.target

			if (target.tagName == 'a' || _.parents(target, 'a')) {
				return;
			}

			var link = node.querySelector('a.post-link,a.read-more')
			link = link ? link : node.querySelector('a')

			if (!location) {
				return;
			}

			var e2 = new Event('click', { cancelable: true })

			link.dispatchEvent(e2)

			if (!e2.defaultPrevented) {
				if (!e.ctrlKey && !e.metaKey) {
					window.location = link.href
				} else {
					window.open(link.href)
				}
			}

		}

		node.addEventListener('touchend', click)
		node.addEventListener('click', click)

	})
})();

(function () {

	// --------------------------------------------------------------------------------------------
	// Misc


	// Privacy settings
	_.toArray(document.querySelectorAll('.privacy-settings a')).forEach(function (node) {
		node.addEventListener('click', function (e) {
			e.preventDefault()

			if (typeof window.Optanon != 'undefined') {
				window.Optanon.ToggleInfoDisplay()
			}
		})
	})


	// --------------------------------------------------------------------------------------------
	// Tabcontainer

	_.toArray(document.querySelectorAll('.tab-navigation a')).forEach(function (node) {
		node.addEventListener('click', function (e) {
			e.preventDefault()

			var container = node.closest('.tab-container')

			// Remove active classes
			container.querySelector('.tab-navigation .active').classList.remove('active')
			container.querySelector('.tab-pane.active').classList.remove('active')

			// Add active classes
			node.parentNode.classList.add('active')
			container.querySelector(node.getAttribute('href')).classList.add('active')

		})
	})
})();

(function () {

	// --------------------------------------------------------------------------------------------
	// Popups

	var popups = document.querySelectorAll('.popup-banner')

	if (!popups.length) {
		return;
	}

	// Initialize popup
	_.toArray(popups).forEach(function (popup) {

		var close = document.createElement('i')
		close.classList.add('popup-close')
		close.classList.add('icon-times')

		close.addEventListener('click', function (e) {
			e.preventDefault()

			popup.classList.remove('active')
			document.body.classList.remove('backdrop')
		})

		var container = document.createElement('div')
		container.classList.add('popup-container')
		container.appendChild(close)

		_.toArray(popup.childNodes).forEach(function (child) {
			container.appendChild(child)
		})

		var title = container.querySelector('.popup-title')

		if (title) {
			title.classList.add('style-h3')
		}

		popup.appendChild(container)
		document.body.appendChild(popup)
	})

	// Observe popup click
	_.toArray(document.querySelectorAll('a[data-popup]')).forEach(function (node) {
		node.addEventListener('click', function (e) {
			e.preventDefault()

			var popup = document.getElementById(node.dataset.popup)
			popup.classList.toggle('active')
			document.body.classList.toggle('backdrop')
		})
	})

	// Observe backdrop click
	document.body.addEventListener('click', function (e) {
		if (e.target.classList.contains('backdrop')) {
			var popup = document.querySelector('.popup-banner.active')

			if (popup) {
				popup.classList.remove('active')
				document.body.classList.remove('backdrop')
			}
		}
	})
})();


(function () {

	_.toArray(document.querySelectorAll('.js-aanbod-entry')).forEach(function (node) {

		node.addEventListener('click', function (e) {
			e.preventDefault()

			if (node.classList.contains('expanded')) {
				return node.classList.remove('expanded')
			}

			// Remove current expanded element
			var active = document.querySelector('.aanbod-table-row.expanded')

			if (active) {
				active.classList.remove('expanded')
			}

			// Expand
			node.classList.add('expanded')

			// Trigger load
			if (node.classList.contains('loaded')) {
				return;
			}

			// Load contents
			node.classList.add('loaded')

			fetch('/welkom-catalogue/info.php?id=' + node.dataset.id)
				.then(function (response) {
					return response.text();
				})
				.then(function (response) {
					node.nextSibling.innerHTML = response
				})
				.catch(function () {

				})

		})

	})

})();

(function () {
	// Patch step container 
	// As pages can be cached the default date might not be up to date

	var date = new Date()
	date = date.getFullYear() + '-' + (date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)) + '-' + (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())

	_.toArray(document.querySelectorAll('.section-steps ul')).forEach(function (node) {
		var base = node.dataset.base

		if (!base || base == date) {
			return;
		}
		_.toArray(node.querySelectorAll('.date')).forEach(function (node) {

			var date = new Date()
			date = new Date(date.setDate(date.getDate() + parseInt(node.dataset.step)))

			node.innerHTML = date.getDate() + '/' + (date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)

		})
	})


})();

// Readmore
(function () {

	_.toArray(document.querySelectorAll('.content-description .readmore')).forEach(function ($link) {
		var $wrap = $link

		while (!$wrap.classList.contains('content-description')) {
			$wrap = $wrap.parentNode
		}

		$link.addEventListener('click', function (e) {
			e.preventDefault()

			$wrap.classList.add('expanded')
		})
	})
})();

// Countdown
(function () {
	class CountDown {
		constructor(el) {
			this.el = el;

			this.days = 1000 * 60 * 60 * 24;
			this.hours = 1000 * 60 * 60;
			this.minutes = 1000 * 60;
			this.seconds = 1000;

			this.date = Date.parse(this.el.getAttribute('data-date'));

			this.run()
		}

		run() {
			/* Grab the remaining time in days, hours, minutes and seconds. Assign them to the amounts object so they can be inserted into the squares accordingly. */
			let remaining = Math.max(this.date - Date.parse(new Date()), 0);
			let remainingHours = !this.el.querySelector('.square.days') ? remaining : remaining % this.days;
			let remainingMinutes = remainingHours % this.hours;
			let remainingSeconds = remainingMinutes % this.minutes;

			const amounts = {
				days: Math.floor(remaining / this.days),
				hours: Math.floor(remainingHours / this.hours),
				minutes: Math.floor(remainingMinutes / this.minutes),
				seconds: Math.floor(remainingSeconds / this.seconds)
			};

			[].forEach.call(this.el.querySelectorAll('.square'), square => {
				const squareFormat = square.getAttribute('data-format');
				const amount = amounts[squareFormat]

				var content = amount < 10 ? '0' + amount : amount
				content = (content + '').split('')
				content = '<span class="number">' + content[0] + '</span>'
					+ '<span class="number">' + content[1] + '</span>'

				square.querySelector('.amount').innerHTML = content;

				if (squareFormat == 'days' && amount == 0) {
					square.classList.add('is-passed')
				}

				if (amount == 1) {
					square.classList.add('is-single')
					square.classList.remove('is-plural')
				}
				else {
					square.classList.remove('is-single')
					square.classList.add('is-plural')
				}
			});



			/* Rinse and repeat, FOR ETERNITYYYYYYY */
			if (remaining > 0) {
				setTimeout(this.run.bind(this), 1000);
			}
		}
	}

	// Initialize countdown
	_.toArray(document.querySelectorAll('.countdown-wrapper')).forEach(function (el) {
		new CountDown(el)
	})
})();
